// HTTP adapter of the attachment queue (P12): idempotent PUT of raw bytes with the client file id and SHA-256.
import { api } from './client';
import { PT, type FileTransport, type ServerFile } from '@/sync/files';

export const httpFileTransport: FileTransport = {
  async upload(workspaceId, taskId, fileId, name, sha256, body, role) {
    // v10.1: a project's comment thread (`pt-{projectId}`) uploads project files.
    const path = taskId.startsWith(PT) ? `/workspaces/${workspaceId}/projects/${taskId.slice(PT.length)}/files/${fileId}` : `/workspaces/${workspaceId}/tasks/${taskId}/files/${fileId}`;
    const r = await api<{ file: ServerFile } | ServerFile>('PUT', path, undefined, {
      raw: { body, headers: { 'X-File-Name': encodeURIComponent(name), 'X-File-Sha256': sha256, ...(role ? { 'X-File-Role': role } : {}) } },
    });
    return 'file' in r ? r.file : r;
  },
  async remove(workspaceId, fileId) {
    await api('DELETE', `/workspaces/${workspaceId}/files/${fileId}`);
  },
};
